import { render } from "./MessageBoxV2.vue?vue&type=template&id=616f3ae0&scoped=true"
import script from "./MessageBoxV2.vue?vue&type=script&lang=js"
export * from "./MessageBoxV2.vue?vue&type=script&lang=js"

import "./MessageBoxV2.vue?vue&type=style&index=0&id=616f3ae0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-616f3ae0"]])

export default __exports__